(function () {
  if (window.promoCodeChipReady) return;
  window.promoCodeChipReady = true;

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-pcc-copy]');
    if (!chip) return;
    // Chips can sit inside a clickable card link; copy instead of navigating
    event.preventDefault();
    var value = chip.querySelector('.pcc-value');
    var code = chip.dataset.pccCopy;
    var done = function () {
      if (!value) return;
      value.textContent = chip.dataset.pccCopied || 'Copied!';
      clearTimeout(chip.pccTimer);
      chip.pccTimer = setTimeout(function () {
        value.textContent = code;
      }, 1800);
    };
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      done();
    }
  });
})();
